// /store/modules/customer.js
import apiClient from "../../plugins/axios";
import router from "../../router";

export default {
  namespaced: true,
  state: () => ({
    customer: null,
    loading: false,
    customerDialog: false,
    tables: [],
    customerLogins: [],
  }),
  mutations: {
    setCustomer(state, customer) {
      state.customer = customer;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCustomerDialog(state, customerDialog) {
      state.customerDialog = customerDialog;
    },
    resetCustomer(state) {
      state.customer = null;
      state.tables = [];
      state.customerLogins = [];
    },
    setTables(state, tables) {
      state.tables = tables;
    },
    setCustomerLogins(state, customerLogins) {
      state.customerLogins = customerLogins;
    },
  },
  actions: {
    async fetchCustomerData({ commit, dispatch }, customerId) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getCustomerById?customerId=${customerId}`
        );
        commit("setCustomer", response.data);
        commit("setCustomerDialog", true);
        dispatch("fetchTablesOccupation");
        dispatch("fetchCustomerLogins");
      } catch (error) {
        console.error("Failed to fetch customer data:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchTablesOccupation({ commit, state }) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getTablesOccupation?customerId=${state.customer._id}`
        );
        commit("setTables", response.data);
      } catch (error) {
        console.error("Failed to fetch tables occupation:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchCustomerLogins({ commit, state }) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getCustomerLoginsByCustomerID?customerId=${state.customer._id}`
        );
        commit("setCustomerLogins", response.data);
      } catch (error) {
        console.error("Failed to fetch customer logins:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async deleteCustomerLogin({ dispatch }, customerLoginId) {
      try {
        const response = await apiClient.delete(
          `/actions/deleteCustomerLogin/${customerLoginId}`
        );
        await dispatch("fetchCustomerLogins"); // Refresh the customer logins
        return response.data; // Return success message
      } catch (error) {
        console.error("Failed to delete customer login:", error);
        return false; // Return failure
      }
    },
    setCustomerDialog({ commit }, customerDialog) {
      commit("setCustomerDialog", customerDialog);
    },
    closeCustomerDialog({ commit, rootState }) {
      router.replace(rootState.agency.dialogReturnRoute);
      commit("resetCustomer");
      commit("setCustomerDialog", false);
    },
    resetCustomer({ commit }) {
      commit("resetCustomer");
    }
  },
};

